import { Component, Input, HostListener, Output, EventEmitter, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, FormArray } from '@angular/forms';

import { BehaviorSubject, debounceTime, filter, Subscription } from 'rxjs';

import { AREA_COORDS_VALIDATOR } from '@commons/forms/validators/area-coords-validator.function';
import { AreaTypeEnum } from '@commons/enums/area-type.enum';
import { Point } from '../../../commons/models/domain/Point';
import { Area } from '../../../commons/models/domain/Area';
import { Tag } from '../../../commons/models/domain/Tag';
import { AreaDrawerService, State as AreaDrawerState } from '@commons/services/map/drawer/area/area-drawer.service';
import { AreaService } from '@commons/services/area/area.service';
import { NotificationService } from '@commons/services/notification/notification.service';
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'tk-area-form',
    styleUrls: ['./area-form.component.less'],
    templateUrl: './area-form.component.html',
    encapsulation: ViewEncapsulation.None
})
export class AreaFormComponent implements OnInit, OnDestroy {

    /**
     * Area
     */
    @Input() public area?: Area;

    /**
     * Subject for selected area type communication: create area componenet -> form component
     */
    @Input() public selectedAreaTypeSubject?: BehaviorSubject<AreaTypeEnum | undefined>;

    /**
     * Subject for saved area communication: form component -> create area component
     */
    @Output() onSave: EventEmitter<any> = new EventEmitter<any>();


    @Output() onDelete: EventEmitter<any> = new EventEmitter<any>();

    /**
     * Filter form
     */
    public form: FormGroup;

    /**
     * Thickness interval in meters
     */
    private readonly THICKNESS_INTERVAL_IN_METERS = 5;

    private readonly MINIMAL_THICKNESS_IN_METERS = 10;

    /**
     * Subsription to selected area type stream
     */
    private selectedAreaTypeSub?: Subscription;

    /**
     * Subscription for drawn area
     */
    private drawnAreaSub: Subscription;

    /**
    * Subscription to stream of value changes
    */
    private readonly formValueChangesSub: Subscription;

    /**
     * Coords
     */
    private coords?: Point[];

    /**
     * For template
     */
    public AreaTypeEnum = AreaTypeEnum;

    /**
     *
     */
    public get isSavingEnabled(): boolean {
        return true;// this.form.valid && this.form.dirty;
    }

    /**
     * Name for just created area
     */
    public newAreaNamePlaceHolder = '';

    /**
     * Component constructor
     * @param $fb form builder
     * @param $webAccess web access service
     * @param $areaDrawer area drawer service
     */
    constructor(
        private $fb: FormBuilder,
        private $area: AreaService,
        private $areaDrawer: AreaDrawerService,
        private $msg: NotificationService,
        private translateService: TranslateService,
    ) {
      this.translateService.get('map.new-area').subscribe(t => this.newAreaNamePlaceHolder = t);

        // Prepare form and control
        this.form = this.$fb.group({
            Id: [null],
            Nm: [this.newAreaNamePlaceHolder, Validators.required],
            Th: [this.MINIMAL_THICKNESS_IN_METERS, Validators.required],
            Tp: [null, Validators.required],
            Coords: [[], AREA_COORDS_VALIDATOR],
            Tg: [[]],
        });

        // Subscribe for form value changes
        this.formValueChangesSub = this.form.valueChanges.pipe(debounceTime(200)).subscribe(value => {
            console.log('!!!!!!', value);
            this.$areaDrawer.remove();
            this.$areaDrawer.setArea(value as Area, true); // inEdition = true
            this.$areaDrawer.draw();
        });

        // Subscribe for drawn area
        this.drawnAreaSub = this.$areaDrawer.drawnArea$.pipe(debounceTime(200)).subscribe(area => {
            console.log(1234, area);
            this.area = area;
            this.form.patchValue(this.area, { emitEvent: false });
            this.form.markAsDirty();
        });
    }


    /**
     * On init lifecycle hook
     */
    public ngOnInit(): void {

        this.$areaDrawer.areaDrawerState = AreaDrawerState.Default;

        if (this.area) {
            console.log(321, this.area);
            this.form.patchValue(this.area);
        } else {
            console.log(43, this.selectedAreaTypeSubject?.value);
            this.form.markAsDirty();
            this.selectedAreaTypeSub = this.selectedAreaTypeSubject!
                .pipe(filter(areaType => areaType != null))
                .subscribe(areaType => {
                    this.form.controls['Tp'].setValue(areaType);
                });
        }
    }


    /**
     * On destroy lifecycle hook
     */
    public ngOnDestroy(): void {

        if (this.formValueChangesSub) {
            this.drawnAreaSub.unsubscribe();
        }
        if (this.formValueChangesSub) {
            this.formValueChangesSub.unsubscribe();
        }
        if (this.selectedAreaTypeSub) {
            this.selectedAreaTypeSub.unsubscribe();
        }
    }


    /**
     * Substracts thickness
     */
    public subThickness(): void {

        const oldValue = this.form.controls['Th'].value;
        let newValue = oldValue - this.THICKNESS_INTERVAL_IN_METERS;

        if (newValue <= this.MINIMAL_THICKNESS_IN_METERS) {
            newValue = this.MINIMAL_THICKNESS_IN_METERS;
        }

        this.form.controls['Th'].setValue(newValue);
        this.form.markAsDirty();

    }


    /**
     * Adds thickness
     */
    public addThickness(): void {

        const oldValue = this.form.controls['Th'].value;
        const newValue = oldValue + this.THICKNESS_INTERVAL_IN_METERS;
        this.form.controls['Th'].setValue(newValue);
        this.form.markAsDirty();
    }


    /**
     * Handles close event with selected tags
     * @param selectedTags
     */
    public handleOnSelectedTags(selectedTags: Tag[]): void {

        this.form.controls['Tg'].setValue(selectedTags);
        this.form.markAsDirty();
    }

    /**
     * Saves area
     */
    public save(): void {

        if (!this.isSavingEnabled) {
            return;
        }


        // saveOrUpdate
        const area = <Area>this.form.getRawValue();

        this.$area.saveAreaDetails$(area)
            .subscribe(_area => {
                this.$msg.showSuccess('Dane obszaru zapisano poprawnie.');
                this.onSave.emit(_area);
                this.form.markAsPristine();
            });
    }

    public onDeleteDone() {
        this.onDelete.emit(this.area);
    }
}

